export default __webpack_public_path__ + "static/media/map.d5a09f66.jpg";